/* eslint-disable max-lines-per-function */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tageszeit } from './Tageszeit';
import { faDropletPercent } from '@fortawesome/pro-regular-svg-icons';
import { Wetter } from '@/domain/controlling/entities/wetter';
import { TemperatureDisplay } from './TemperatureDisplay';
import { WeathercodeMapping, weathercodeMappings } from '../utils';

export function WeatherCardDay({
  weatherOfTheDay,
}: {
  weatherOfTheDay: Wetter[];
}) {
  const weatherIcons: WeathercodeMapping[] = (weatherOfTheDay ?? [])
    .map((day) => weathercodeMappings[day?.wettercode])
    .filter((mapping) => mapping !== undefined);

  return (
    <div className="flex flex-row gap-4 grow">
      {weatherOfTheDay.map((weather, index) => (
        <div
          key={index}
          className="grow flex flex-col gap-5 shadow-none border-[1px] rounded-lg border-neutrals-N300 p-3 w-44 h-32 justify-between">
          <div className="flex flex-row justify-between">
            <div className="text-xs justify-end bg-neutrals-N200 rounded-full px-1 py-(6px) text-neutrals-N800">
              {Tageszeit({ uhrzeit: weather.uhrzeit })}
            </div>
            {weatherIcons[index]?.icon?.day && (
              <FontAwesomeIcon
                icon={weatherIcons[index].icon.day}
                className="h-6"
              />
            )}
          </div>
          <div className="flex flex-col gap-1 justify-end">
            <div className="text-xs text-neutrals-N900">
              {weather?.wetterZustand}
            </div>
            <div className="flex flex-row gap-2">
              <TemperatureDisplay
                weatherOfTheDay={[weather]}
                temperature={weather?.maxTemperatur.wert}
              />
              <div className="text-base text-neutrals-N700">/</div>
              <TemperatureDisplay
                className="font-extrabold"
                temperature={weather?.minTemperatur.wert}
                weatherOfTheDay={[weather]}
              />
              <div>•</div>
              <div className="text-base flex flex-row gap-1 items-center text-neutrals-N900">
                {weather?.niederschlagWahrscheinlichkeit}
                <FontAwesomeIcon icon={faDropletPercent} className="h-3" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
